import { render, staticRenderFns } from "./videoDaHua.vue?vue&type=template&id=4b06a159&scoped=true&"
import script from "./videoDaHua.vue?vue&type=script&lang=js&"
export * from "./videoDaHua.vue?vue&type=script&lang=js&"
import style0 from "./videoDaHua.vue?vue&type=style&index=0&id=4b06a159&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06a159",
  null
  
)

export default component.exports